import { Inject, Component, DestroyRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import {
    AppointmentBookingService,
    AppointmentSlotsModel,
    ConfigInstanceToken,
    ConfigInterface,
} from '@evorait/pace-core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'pace-confirmation-appointment',
    templateUrl: './confirmation-appointment.component.html',
    providers: [AppointmentBookingService],
    standalone: false,
})
export class ConfirmationAppointmentComponent implements OnInit {
    @Input() public model: AppointmentSlotsModel;

    @Output() public modalResult = new EventEmitter<AppointmentSlotsModel>();

    public confirmationAppointmentForm: FormGroup;
    public confirmationAppointmentFormChildren: FormArray;
    public isDedicatedResourceEnabled = false;
    public isLoading = false;

    public constructor(
        private readonly formBuilder: FormBuilder,
        @Inject(ConfigInstanceToken) private readonly configService: ConfigInterface,
        public readonly modalInstance: BsModalRef,
        public readonly appointmentBookingService: AppointmentBookingService,
        public readonly destroyRef: DestroyRef,
    ) {
        this.isDedicatedResourceEnabled = this.configService.getAppBookingShowDedicated();
    }

    public ngOnInit(): void {
        this.confirmationAppointmentFormChildren = this.formBuilder.array([]);
        this.confirmationAppointmentForm = this.formBuilder.group({
            children: this.confirmationAppointmentFormChildren,
        });
    }

    public searchForAppointments(): void {
        this.isLoading = true;
        this.appointmentBookingService
            .getAppointment(this.model)
            .pipe(
                finalize(() => {
                    this.isLoading = false;
                }),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe();
    }

    public saveDetails(): void {
        this.modalResult.emit(this.model);
        this.modalInstance.hide();
    }

    public resetAppointmentSlotsList(): void {
        if (this.model.slotIntervals?.value?.length) {
            this.model.slotIntervals.value.length = 0;
        }
    }

    public bookSlot(index: number): void {
        this.model.updateLoadingStatus(index, true);
        this.appointmentBookingService
            .bookAppointment(this.model, index)
            .pipe(
                finalize(() => this.model.updateLoadingStatus(index, false)),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe((status) => {
                if (status) {
                    this.modalResult.emit(this.model);
                    this.modalInstance.hide();
                }
            });
    }
}
